export enum SectionType {
  LoginLink = 'loginLink',
  RequestLink = 'requestLink',
  MarketSelector = 'MarketSelectorType',
}
